'use client';

import { FC, ReactNode } from 'react';

import { AuthStoreProvider, useCreateAuthStore } from 'src/stores/authStore';
import { CarComparisonStoreProvider, useCreateCarComparisonStore } from 'src/stores/carComparisonStore';
import { CarStatusStoreProvider, useCreateCarStatusStore } from 'src/stores/carStatusStore';
import { CartStoreProvider, useCreateCartStore } from 'src/stores/cartStore';
import { DocumentStoreProvider, useCreateDocumentStore } from 'src/stores/documentStore';
import { LiveChatStoreProvider, useCreateLiveChatStore } from 'src/stores/liveChatStore';
import { AuthManager } from 'src/stores/managers/AuthManager';
import { CarStatusManager } from 'src/stores/managers/CarStatusManager';
import { CartManager } from 'src/stores/managers/CartManager';
import { SavedSearchManager } from 'src/stores/managers/SavedSearchManager';
import { WatchListManager } from 'src/stores/managers/WatchListManager';
import { ModalStore } from 'src/stores/modalStore';
import { RecentFilterSearchStoreProvider, useCreateRecentFilterSearchStore } from 'src/stores/recentFilterSearchStore';
import { SavedSearchStoreProvider, useCreateSavedSearchStore } from 'src/stores/savedSearchStore';
import { WatchlistStoreProvider, useCreateWatchlistStore } from 'src/stores/watchListStore';

interface Props {
  children: ReactNode;
}

/**
 * Zustand store providers and manager, focussed around Authentication and Snackbar provider
 */
export const StoreProviders: FC<Props> = ({ children }) => {
  const createAuthStore = useCreateAuthStore({});
  const createCartStore = useCreateCartStore({});
  const createSavedSearchStore = useCreateSavedSearchStore({});
  const createWatchlistStore = useCreateWatchlistStore({});
  const createLiveChatStore = useCreateLiveChatStore({});
  const createCarStatusStore = useCreateCarStatusStore({});
  const createRecentFilterSearchStore = useCreateRecentFilterSearchStore({});
  const createCarComparisonStore = useCreateCarComparisonStore({});
  const createDocumentStore = useCreateDocumentStore({});

  return (
    <CarStatusStoreProvider createStore={createCarStatusStore}>
      <AuthStoreProvider createStore={createAuthStore}>
        <SavedSearchStoreProvider createStore={createSavedSearchStore}>
          <CartStoreProvider createStore={createCartStore}>
              <DocumentStoreProvider createStore={createDocumentStore}>
              <WatchlistStoreProvider createStore={createWatchlistStore}>
                <LiveChatStoreProvider createStore={createLiveChatStore}>
                  <RecentFilterSearchStoreProvider createStore={createRecentFilterSearchStore}>
                    <CarComparisonStoreProvider createStore={createCarComparisonStore}>
                      <ModalStore>
                        {/* Store managers */}
                        <AuthManager />
                        <CarStatusManager />
                        <SavedSearchManager />
                        <CartManager />
                        <WatchListManager />
                        {children}
                      </ModalStore>
                    </CarComparisonStoreProvider>
                  </RecentFilterSearchStoreProvider>
                </LiveChatStoreProvider>
              </WatchlistStoreProvider>
              </DocumentStoreProvider>
          </CartStoreProvider>
        </SavedSearchStoreProvider>
      </AuthStoreProvider>
    </CarStatusStoreProvider>
  );
};
